 document.addEventListener('DOMContentLoaded', function() {

        function fetchCollectionData(handle) {
     $.ajax({
        url: '/collections/' + handle,
        method: 'GET',
        success: function(response) {
          var $response = $('<div>').html(response);
          var newItems = $response.find('#collection-items-container').html();
          $('#collection-items-container').html(newItems);
    
          // // Update the collection title
          var newTitle = $response.find('.shopify-section--collection-banner .place-self-center .h2').html();
          console.log("newTitle",newTitle);
          $('.shopify-section--collection-banner .place-self-center .h2').html(newTitle);
    
         var newImageUrl = $response.find('.collection-banner picture img').attr('src');
        var newImageSrcset = $response.find('.collection-banner picture img').attr('srcset');
        var $collectionImage = $('.collection-banner picture img');
        
        $collectionImage.attr('src', newImageUrl);
        $collectionImage.attr('srcset', newImageSrcset);
    
        },
        error: function() {
          alert('Failed to load collection items.');
        }
      });
    }

    function debounce(func, wait) {
        let timeout;
        return function(...args) {
            clearTimeout(timeout);
            timeout = setTimeout(() => func.apply(this, args), wait);
        };
    }

    const subcollectionLinks = document.querySelectorAll('.subcollections_section .subcollection__link');

    subcollectionLinks.forEach(link => {
        link.addEventListener('click', debounce(function(event) {
        event.preventDefault();
         subcollectionLinks.forEach(tab => tab.classList.remove('active'));
           this.classList.add('active');
          
        const collectionHandle = this.getAttribute('data-handle');
         fetchCollectionData(collectionHandle);
       }, 300));
    });

      const textarea = document.querySelector('.cart-form__note .textarea');
    const maxChars = 150;
   if(textarea){
    textarea.addEventListener('input', function(event) {
        // Remove any non-alphabetic characters except spaces
        textarea.value = textarea.value.replace(/[^a-zA-Z\0-9s]/g, '');

        // Count the number of alphabetic characters (excluding spaces)
        let alphabeticCharsCount = textarea.value.replace(/\s/g, '').length;

        // If the count exceeds the maxChars limit, trim the value
        if (alphabeticCharsCount > maxChars) {
            let truncatedText = textarea.value.split('').reduce((result, char) => {
                if (alphabeticCharsCount <= maxChars || char === ' ') {
                    result += char;
                } else if (/[a-zA-Z0-9]/.test(char)) {
                    alphabeticCharsCount--;
                    result += char;
                }
                return result;
            }, '');

            textarea.value = truncatedText;
        }
    });

    textarea.addEventListener('keydown', function(event) {
        // Allowed keys: alphabetic characters, spaces, backspace, delete, arrow keys, tab, and enter
        const allowedKeys = ['Backspace', 'Delete', 'ArrowLeft', 'ArrowRight', 'Tab', 'Enter', ' '];

        // Allow the key if it is an allowed key or an alphabetic character
        if (!allowedKeys.includes(event.key) && !/^[a-zA-Z\0-9s]$/.test(event.key)) {
            event.preventDefault();
        }
        
        // Count the number of alphabetic characters (excluding spaces)
        let alphabeticCharsCount = textarea.value.replace(/\s/g, '').length;

        // Prevent further typing if the alphabetic character limit is reached and it's not a control key
        if (alphabeticCharsCount >= maxChars && /^[a-zA-Z0-9]$/.test(event.key)) {
            event.preventDefault();
        }
    });
   } 
  });
